import { env } from 'env';

const isUsingOneDrive = () => {
  return env.usingOneDrive;
};

export default isUsingOneDrive;
